<template>
  <div>
    <b-modal
      title="圖片"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div class="img-modal-container">
        <b-button v-if="isUpload" variant="warning" @click="selectFile('upload_image')">上傳圖片</b-button>

        <div class="img-block">
          <img :src="isUpload ? viewImg : img" />
        </div>

        <input ref="upload_image" type="file" @change="fileUpload()" accept=".jpg,.jpeg,.png" />

        <div v-if="isUpload" class="text-center mt-4">
          <b-button
            class="mr-2"
            variant="success"
            size="sm"
            @click="sumit()"
          >
            確定
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            class="mr-4"
            @click="$emit('change', false)"
          >
            取消
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import baseApi from "@/models/API/baseApi";
import { checkUpdateFile } from "@/models/HELPERS/common.js";

export default {
  name: 'ImgModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    img: {
      type: String,
      required: false
    },
    isUpload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      refsName: '',
      file: '',
      viewImg: ''
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {

  },
  mounted() {
    this.baseApi = new baseApi();
  },
  methods: {
    // 選擇檔案
    selectFile(refsName = 'upload_image'){
      // 初始化檔案輸入值，防止上傳相同檔案沒作用
      this.$refs[refsName].value = '';
      this.refsName = refsName;

      const file_input_element = this.$refs[refsName];

      file_input_element.click();
    },
    // 檔案上傳
    async fileUpload() {
      const file_event = this.$refs[this.refsName];
      const file = this.$refs[this.refsName].files[0];
      const limit_mb = 20; // 限制檔案大小
      const file_accept = file_event.accept.split(".").join('').replace(/,/g, '/'); // 限制檔案類型
      const check_status = checkUpdateFile(file, file_accept, limit_mb);

      // 判斷檔案類型是否符合格式 & 大小限制20MB
      if (check_status) {
        this.file = file;
        this.viewImg = await this.getBase64(file);
      } else {
        const result = { message: `只能上傳${file_accept}檔案，大小上限為${limit_mb}MB`, title: '上傳身故證明' };
        this.baseApi.toast(() => {}, result, false);
      }
    },
    /**
     * 取得圖片Base64字串
     * @return {String}
     */
    async getBase64(file) {
      // Returns a promise which gets resolved or rejected based on the reader events
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // Sets up even listeners BEFORE you call reader.readAsDataURL

        reader.onload = (e) => {
          // this.zoomOutIcon.push(e.target.result);

          return resolve(e.target.result);
        };

        reader.onerror = (e) => {
          return reject(e);
        };

        // Calls reader function
        reader.readAsDataURL(file);
      })
    },
    sumit() {
      this.$emit('uploadImage', this.file);
    }
  }
}
</script>

<style lang="scss" scoped>
.img-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .img-block {
    margin-top: 30px;
    width: 700px;
    height: 700px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
    }
  }

  input[type="file"] {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal/imgModal.vue